import {GridColDef} from '@mui/x-data-grid'

const addedDeviceColumns: GridColDef[] = [
  {field: 'name', headerName: 'Device name', flex: 1},
  {field: 'serialNumber', headerName: 'Serial number', flex: 1},
  {field: 'patientName', headerName: 'Patient', flex: 1},
]

export default addedDeviceColumns
